import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Route, Switch, useLocation, useHistory } from 'react-router-dom';
import { ConnectedRouter } from '@jauntin/react-ui';
import ReactGA from 'react-ga';
import { hotjar } from 'react-hotjar';
import {
  getIsAppDataLoaded,
  getIsInMaintenanceMode,
} from './Helpers/StoreSelectors';
import './App.scss';
import FormContainer from './Containers/FormContainer';
import RefundsCancellationsContainer from './Containers/RefundCancellationsContainer';
import SamplePolicyDocumentContainer from './Containers/SamplePolicyDocumentContainer';
import ThankYouContainer from './Containers/ThankYouContainer';
import Header from './Components/Header';
import Footer from './Components/Footer';
import ScrollToTop from './Helpers/ScrollToTop';
import BrowserFeatures from './Helpers/BrowserFeatures';
import MaintenanceMode from './Components/MaintenanceMode';
import VenueUploader from './Components/VenueUploader/VenueUploader';

const touch = () => {
  const touchClass = BrowserFeatures.isTouch() ? 'touch' : 'no-touch';
  return document.body.classList.add(touchClass);
};
touch();

if (process.env.NODE_ENV === 'production') {
  hotjar.initialize(
    parseInt(process.env.REACT_APP_HOTJAR_ID, 10),
    parseInt(process.env.REACT_APP_HOTJAR_SV, 10),
  );

  // Google Analytics (may be redundant once GA is handled through GTM. See index.html)
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
  ReactGA.pageview(window.location.pathname + window.location.search);
}

const App = () => {
  const isAppDataLoaded = useSelector(getIsAppDataLoaded);
  const isInMaintenanceMode = useSelector(getIsInMaintenanceMode);

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const pushUrl = useSelector((state) => state.router.pushUrl);

  return (
    <>
      {isInMaintenanceMode ? (
        <MaintenanceMode />
      ) : (
        <ConnectedRouter.Router
          dispatch={dispatch}
          location={location}
          history={history}
          pushUrl={pushUrl}
        >
          {isAppDataLoaded ? (
            <div>
              <Switch>
                <Route
                  path="/sample-policy"
                  component={SamplePolicyDocumentContainer}
                />
                <Route
                  path="/refunds-cancellations"
                  component={RefundsCancellationsContainer}
                />
                <Route path="/venue-uploader/:uploadId">
                  <Header />
                  <div className="main-content">
                    <VenueUploader />
                  </div>
                </Route>
                <Fragment>
                  <Header />
                  <div className="main-content">
                    <ScrollToTop>
                      <Switch>
                        <Route
                          path="/thank-you"
                          component={ThankYouContainer}
                        />
                        <Route
                          exact
                          path="/:eventType?/:formPage?"
                          component={FormContainer}
                        />
                      </Switch>
                    </ScrollToTop>
                  </div>
                  <Footer />
                </Fragment>
              </Switch>
            </div>
          ) : (
            <></>
          )}
        </ConnectedRouter.Router>
      )}
    </>
  );
};

export default App;
